import {
  Asset,
  Presentation,
  RenderingObject,
  RenderingObjectGraphic,
  RenderingObjectKind,
  RenderingObjectPresentation,
} from "../generated/gql/graphql";
import { LayoutFull } from "../hooks/use-layout";
import { UpdateRenderingObjectProductInput } from "../hooks/use-update-layout";

export type CanvasObjectBase = Pick<RenderingObject, "scale" | "offset"> & {
  // Optional id (not yet saved to backend)
  id?: string;

  // Internal key for React
  key: string;
};

export type CanvasObjectPresentation = CanvasObjectBase &
  Required<Pick<RenderingObjectPresentation, "presentationId">> & {
    presentation:
      | (Pick<
          Presentation,
          | "id"
          | "name"
          | "productId"
          | "type"
          | "thumbnailUrl"
          | "url"
          | "referenceResolution"
        > & {
          asset: Pick<Asset, "width" | "height"> | null;
        })
      | null;
    productInputs?:
      | RenderingObjectPresentation["productInputs"]
      | UpdateRenderingObjectProductInput[];
  } & {
    kind: RenderingObjectKind.Presentation;
  };

export type CanvasObjectGraphic = CanvasObjectBase &
  Required<Pick<RenderingObjectGraphic, "graphicId">> & {
    kind: RenderingObjectKind.Graphic;
  };

export type CanvasObject = CanvasObjectPresentation | CanvasObjectGraphic;

export function getCanvasObjectsFromRenderingObjects(
  renderingObjects: LayoutFull["renderingObjects"] | undefined | null,
): CanvasObject[] {
  const canvasObjects: CanvasObject[] = [];
  if (!renderingObjects) {
    return canvasObjects;
  }
  for (let index = 0; index < renderingObjects.length; index++) {
    const object = renderingObjects[index];
    const canvasObject = {
      key: object.id ? `existing-${object.id}` : `new-${index}`,
      id: object.id,
      scale: object.scale || 1,
      offset: object.offset ?? null,
    };
    switch (object.__typename) {
      case "RenderingObjectPresentation":
        canvasObjects.push({
          ...canvasObject,
          kind: RenderingObjectKind.Presentation,
          presentationId: object.presentationId,
          presentation: object.presentation,

          productInputs: object.productInputs,
        });
        break;
      case "RenderingObjectGraphic":
        canvasObjects.push({
          ...canvasObject,
          kind: RenderingObjectKind.Graphic,
          graphicId: object.graphicId,
        });
        break;
    }
  }
  return canvasObjects;
}
